export const WeekStartDayDetails = new Map<string, string>([
['sunday', 'Sunday'],
['monday', 'Monday'],
]);
